export const FormTitle = ({ children }: { children: React.ReactNode }) => {
  return <h1 className="text-xl font-semibold leading-7 font-sans">{children}</h1>;
};
